import { render, staticRenderFns } from "./DarkModeFeature.vue?vue&type=template&id=336cb574&"
import script from "./DarkModeFeature.vue?vue&type=script&lang=js&"
export * from "./DarkModeFeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports